import { render } from "./TraficInfoCard.vue?vue&type=template&id=4312d9b1&ts=true"
import script from "./TraficInfoCard.vue?vue&type=script&lang=ts"
export * from "./TraficInfoCard.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Episcenter\\smartCity\\smartcity\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__